import { renderPage } from "renderPage"
import { AccountDocumentIndexPage } from "./Page"

renderPage({ component: AccountDocumentIndexPage })
